import React from 'react';
import { X } from 'lucide-react';
import { Prompt, Category } from '../types';
import { getCategoryName } from '../utils/category';

interface ModalHeaderProps {
  prompt: Prompt;
  categories: Category[];
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  prompt,
  categories,
  onClose,
}) => (
  <div
  className="

    sticky
    top-0
    z-20
    shrink-0

    flex
    items-center
    justify-between

    p-3
    sm:p-5

    border-b
    border-dark-700

    bg-dark-800/95
    backdrop-blur-lg

  "
>
    <div className="flex items-center gap-3">
      <span className="px-3 py-1 bg-purple-900/30 text-purple-300 text-sm rounded-full">
        {
  getCategoryName(
    prompt.categoryId,
    categories,
    prompt.categoryName
  )
}
      </span>
      {prompt.identifier && (
        <span className="text-dark-300 text-sm">
          {prompt.identifier}
        </span>
      )}
    </div>
    <button
      onClick={onClose}
      className="p-2 hover:bg-dark-700 rounded transition-colors"
    >
      <X size={24} />
    </button>
  </div>
);

export default ModalHeader;
